/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { familyPlanningDrugsInvTableGrid } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
// import PaginationBox from './PaginationBox';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getFamilyPlanningDrugsInvData } from '../Store/Actions';

const DisplayFamilyPlanningDrugsInv = () => {
  const dispatch = useDispatch();
  const gridRef = React.useRef();

  // use Selector function

  const isLoading = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsInvReducer?.isLoading
  );
  const {
    displayObj: {
      rebateProgram: getRebateProgramList,
      setRebateProgram: rebateProgramValue,
      quarter: getQuarter,
      rebateProgrameName,
      searchResult: getSearchResult,
    },
  } = useSelector((state) => state?.sharedState?.FamilyPlanningDrugsInvReducer);

  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [searchResultList, setSearchResultList] =
    React.useState(getSearchResult);
  const [filteredRows, setFilteredRow] = React.useState([]);

  const rebateProgramNameValue = rebateProgrameName;
  //   getRebateProgramList?.data?.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${
  //   rebateProgramNameValue?.rebateProgramCd || ''
  // } - ${rebateProgramNameValue?.shortDescr || ''}`;

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // converting date to required payload
  function getQuarterDates(quarter) {
    const year = parseInt(quarter?.slice(-4));
    const quarterNum = parseInt(quarter?.slice(0, 1));
    let startDate;
    let endDate;

    switch (quarterNum) {
      case 1:
        startDate = new Date(year, 0, 1);
        endDate = new Date(year, 2, 31);
        break;
      case 2:
        startDate = new Date(year, 3, 1);
        endDate = new Date(year, 5, 30);
        break;
      case 3:
        startDate = new Date(year, 6, 1);
        endDate = new Date(year, 8, 30);
        break;
      case 4:
        startDate = new Date(year, 9, 1);
        endDate = new Date(year, 11, 31);
        break;
    }

    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    const startStr = startDate?.toLocaleDateString('en-US', options);
    const endStr = endDate?.toLocaleDateString('en-US', options);

    return { startDate: startStr, endDate: endStr };
  }
  const qtr = getQuarterDates(getQuarter);
  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  const [displayedRows, setDisplayedRows] = React.useState(
    searchResultList ?? []
  );
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : searchResultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : 0.0;
  };
  // columns to show total
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        ndc: 'Totals',
        totReimbursedUnits: sum('totReimbursedUnits').toFixed(4),
        rebateBuildAmt: sum('rebateBuildAmt'),
        totReimbursedAmt: sum('totReimbursedAmt'),
      });
    }
    return result;
  };

  // To pin the total row
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [searchResultList, filteredRows, filterApply]);

  // get the API Call
  React.useEffect(() => {
    dispatch(
      getFamilyPlanningDrugsInvData({
        rebateProgramCd: rebateProgramValue,
        quarter: getQuarter,
        beginDate: qtr.startDate,
        endDate: qtr.endDate,
      })
    );
  }, []);

  // SET data from MCO
  React.useEffect(() => {
    setSearchResultList(getSearchResult);
  }, [getSearchResult]);

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // pdf header
  let fourthInfo = '';
  let thirdInfo = '';

  thirdInfo = `Rebate Program:${rebateProgramNameValue}`;
  fourthInfo = `Quarter:${getQuarter}`;

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="State Reports"
        parent2="Display Family Planning Drugs Inv"
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program "
                          id="Rebate Program "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Quarter "
                          id="Quarter "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={getQuarter}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="clearfix">
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
          >
            <TableGrid
              ref={gridRef}
              rowSelection="single"
              data-testid="onEditingStopped"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={
                fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
              }
              rowData={searchResultList.map((item) => {
                return {
                  ...item,
                  totReimbursedUnits: item.totReimbursedUnits
                    ? item?.totReimbursedUnits.toFixed(4)
                    : '0.00',
                  rebateBuildAmt: item.rebateBuildAmt
                    ? parseFloat(item?.rebateBuildAmt.toFixed(2))
                    : '0.00',
                  totReimbursedAmt: item.totReimbursedAmt
                    ? parseFloat(item?.totReimbursedAmt.toFixed(2))
                    : '0.00',
                };
              })}
              columnDefs={familyPlanningDrugsInvTableGrid}
              exportFile
              animateRows
              sideBar={false}
              reportName="Family planning drugs inv report"
              fileName="FamilyPlanningDrugInvoiced"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              isScrollOn
              onCellFocused={onCellFocused}
              hideColumnsInPdf
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              onFilterData={onFilterChanged}
              // handleViewHistory
              info={{
                fourthInfo,
                thirdInfo,
              }}
              pinnedBottomRowData={pinnedBottomRowData}
              getFilterApply={getFilterApply}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayFamilyPlanningDrugsInv;
